import {FileUpload} from 'components/FileUpload';
import {connect} from 'react-redux';
import AnalyticsGateway from '../lib/AnalyticsGateway';
import {Icon} from 'semantic-ui-react';
import CoverImages from '../lib/CoverImages';
import actionCreators from '../actionCreators/index';

const typeToLayout = {
  property: 'half',
  lifestyle: 'large',
};

const mapStateToProps = (state) => {
  return {
    header: <Icon name="plus" style={{color: '#6f8a94', paddingTop: '30px', marginRight: 0}}/>,
    description: <span style={{
      fontSize: '16px',
      fontWeight: '600',
      position: 'relative',
      top: '25px',
    }}>Upload Image</span>,
    accept: 'image/png, image/jpeg',
    uploadProgress: state.uploadProgress,
    uploadText: 'Uploading cover image...',
    propertyId: state.propertyDetail.propertyId,
    className: 'select-image upload-image',
    layout: typeToLayout[CoverImages.selectedImage(state).type],
  };
};

const layoutToType = {
  half: 'property',
  large: 'lifestyle',
};

const mapDispatchToProps = (dispatch, ownProps) => (
  {
    onUpload: (files, event, propertyId, layout) => {
      dispatch(actionCreators.addCoverImage({
        type: layoutToType[layout],
        file: files[0],
        callback: ownProps.onUpload,
      }));

      const eventType = event.type === 'drop' ? 'Drop' : 'Browse';
      AnalyticsGateway.sendEvent({
        eventName: 'Upload Cover Image',
        properties: [
          {label: 'Page', value: 'Customise Report'},
          {label: 'Property ID', value: propertyId},
          {label: 'Upload Method', value: eventType},
          {label: 'Image Name', value: files[0].name},
          {label: 'Image Type', value: files[0].type},
          {label: 'Layout', value: layout},
        ]
      });
    }
  }
);

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  onUpload: (files, event) => {
    const {layout, propertyId} = stateProps;
    dispatchProps.onUpload(files, event, propertyId, layout);
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(FileUpload);